import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { useContent } from "../context/ContentContext";

export const Layout = () => {
  const { pathname } = useLocation();
  const { refresh } = useContent();

  useEffect(() => {
    window.scrollTo(0, 0);
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <div className="App min-h-screen flex flex-col bg-amf-cream">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
